module.exports = __webpack_public_path__ + "static/media/alphabet.54659060.jpg";